import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
export function FinalCTA() {
  return <Section background="gradient" className="text-center py-32" data-id="element-1">
      <div className="max-w-2xl mx-auto" data-id="element-2">
        <h2 className="text-3xl md:text-5xl font-serif text-white mb-8" data-id="element-3">
          La decisión real
        </h2>

        <p className="text-xl text-slate-300 mb-8 leading-relaxed" data-id="element-4">
          Puedes seguir intentando "dormir" como si fuera fuerza de voluntad… o
          puedes entrenar un cierre pequeño que tu cerebro respete.
        </p>

        <p className="text-xl text-white font-medium mb-12" data-id="element-5">
          Porque la noche no es para resolver tu vida.
          <br data-id="element-6" />
          <span className="text-[#d4a574]" data-id="element-7">
            La noche es para recuperar tu energía para vivirla.
          </span>
        </p>

        <Button className="text-xl px-10 py-5" data-id="element-8">
          Compra ahora y empieza esta noche
        </Button>
      </div>
    </Section>;
}